(function(){
  function onReady(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function(){
    var v = document.getElementById('bgVideo');
    if (v){
      var DESKTOP = v.dataset.desktop || '';
      var MOBILE  = v.dataset.mobile  || '';
      var POSTER  = v.dataset.poster  || '';

      function isDesktop(){ return window.innerWidth > 999; }

      function setSource(){
        var desk = isDesktop();
        var src  = desk ? DESKTOP : MOBILE;
        if (src && v.currentSrc !== src){
          v.muted = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
          v.autoplay = true;

          v.src = src;
          if (!desk && POSTER) v.poster = POSTER; else v.removeAttribute('poster');
          v.preload = 'auto';
          v.load();
        }
      }

      function tryPlay(){ /* no-op: iOS Low Power may block autoplay */ }


      setSource();
      v.addEventListener('canplay', tryPlay, { once:true });
      window.addEventListener('resize', setSource);
    }

    // --- CTA → fade out → reveal menu, and switch cursor
    var ctaLink = document.querySelector('.cta-link');
    var ctaText = document.querySelector('.cta-text');
    var ctaWrap = document.querySelector('.cta-wrap');
    var menu    = document.querySelector('.menu-wrap');
    // --- Helper: show Screen B right away
    function showScreenB(){
      if (ctaWrap) ctaWrap.style.display = 'none';
      if (menu)    menu.classList.add('show');
      if (window.rpgUseLogoCursor) window.rpgUseLogoCursor();
    }
        // Start on Screen B when the URL says so (e.g., /pages/main-menu?screen=B)
    try{
      var params = new URLSearchParams(location.search);
      if (params.get('screen') === 'B') {
        showScreenB();
      }
    } catch(e){}

    if (ctaLink && ctaText && menu){
      ctaLink.addEventListener('click', function(e){
        e.preventDefault();
        if (v) v.play().catch(function(){});
        ctaText.classList.add('fade-out');
        ctaText.addEventListener('animationend', function onEnd(){
          ctaText.removeEventListener('animationend', onEnd);
          showScreenB(); // use the helper

          // Reflect state in the URL so returns land on Screen B
          try{
            var url = new URL(location.href);
            url.searchParams.set('screen', 'B');
            history.replaceState({}, '', url);
          } catch(e){}
        });
      });
    }
  });
})();
/* Main menu: How to Play guide */
(function () {

  function initGuide() {

    var menu = document.querySelector('.menu-wrap');

    if (!menu) return;


    /* How to Play button now exists directly in page.mainmenu.liquid */
    var trigger = menu.querySelector('.mm-help-trigger');

    if (!trigger) return;


    /*
     * Because your website uses SPA-style navigation,
     * the dialog can survive when the actual page HTML gets replaced.
     *
     * We therefore reuse the existing dialog instead of creating
     * duplicates.
     */
    var dialog = document.getElementById('mm-guide');


    /* Create the popup only if one doesn't already exist */
    if (!dialog) {

      dialog = document.createElement('dialog');

      dialog.id = 'mm-guide';
      dialog.className = 'mm-guide';

      dialog.setAttribute(
        'aria-labelledby',
        'mm-guide-title'
      );


      dialog.innerHTML =
        '<button type="button" class="mm-guide-close" aria-label="Close How to Play">&times;</button>' +

        '<h2 id="mm-guide-title">How to Play</h2>' +

        '<div class="mm-guide-section">' +
          '<h3>Start Game</h3>' +
          '<p>Acquire our custom Attack on Titan hoodie, sweatpants or the full set in order to acquire badges and complete the game</p>' +
        '</div>' +

        '<div class="mm-guide-section">' +
          '<h3>My Items</h3>' +
          '<p>Your purchased items unlock badges which are visible here. Your items and badges will grant you special perks for future collections. Log in to view your inventory</p>' +
        '</div>' +

        '<div class="mm-guide-section">' +
          '<h3>World Map</h3>' +
          '<p>See the Jiyuda world map. We are currently in Shiganshina District. Where shall we go to next?</p>' +
        '</div>' +

        '<a class="mm-guide-play" href="/pages/basement">Let’s Play</a>';


      document.body.appendChild(dialog);

    }


    /*
     * Every time Screen B gets loaded again,
     * remember the CURRENT How to Play button.
     */
    dialog.__mmTrigger = trigger;


    /*
     * Connect the CURRENT button to the popup.
     */
    if (!trigger.dataset.mmGuideWired) {

      trigger.dataset.mmGuideWired = '1';

      trigger.addEventListener('click', function () {

        if (!dialog.open) {
          dialog.showModal();
        }

      });

    }


    /*
     * These popup listeners only need to be created once.
     */
    if (!dialog.dataset.mmGuideWired) {

      dialog.dataset.mmGuideWired = '1';


      var closeButton =
        dialog.querySelector('.mm-guide-close');


      if (closeButton) {

        closeButton.addEventListener(
          'click',
          function () {
            dialog.close();
          }
        );

      }


      /*
       * Click outside the popup to close.
       */
      dialog.addEventListener(
        'click',
        function (event) {

          if (event.target !== dialog) return;


          var r =
            dialog.getBoundingClientRect();


          if (
            event.clientX < r.left ||
            event.clientX > r.right ||
            event.clientY < r.top ||
            event.clientY > r.bottom
          ) {

            dialog.close();

          }

        }
      );


      /*
       * Return focus to whichever How to Play
       * button currently exists on Screen B.
       */
      dialog.addEventListener(
        'close',
        function () {

          var currentTrigger =
            dialog.__mmTrigger;


          if (
            currentTrigger &&
            currentTrigger.isConnected
          ) {

            currentTrigger.focus({
              preventScroll: true
            });

          }

        }
      );


      /*
       * Close popup when Let's Play is clicked.
       */
        var playLink = dialog.querySelector('.mm-guide-play');

        if (playLink) {

          var doorSfxUrl = menu.dataset.doorSfx || '';
          var doorSfx = doorSfxUrl ? new Audio(doorSfxUrl) : null;

          if (doorSfx) {
            doorSfx.volume = 1;
            doorSfx.preload = 'auto';
          }

          playLink.addEventListener('click', function () {

            if (doorSfx) {
              try {
                doorSfx.currentTime = 0;
                doorSfx.play();
              } catch (e) {}
            }

            if (dialog.open) {
              dialog.close();
            }

          });

        }


      /*
       * Safety close when leaving page.
       */
      window.addEventListener(
        'pagehide',
        function () {

          if (dialog.open) {
            dialog.close();
          }

        }
      );

    }

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initGuide
    );

  } else {

    initGuide();

  }

})();
